import { ranks } from '../data/data';

const Card = ({ card, openCardModal }) => {
    const handleEdit = () => {
        openCardModal(card);
    }

    return (
        <div className={`card ${card.rank===5?"eclipse":""}`} onClick={handleEdit} style={{boxShadow:"0 0 12px "+ranks[card.rank].color}}>
            <div className={`card-top ${card.type===16?"instru":""}`} style={{ "--card-image": card.img?`url("${card.img}")`:'' }}>
                <div className="card-rank" style={{backgroundColor:ranks[card.rank].color}}>{ranks[card.rank].short}</div>
            </div>
            <div className="card-bottom" style={{ backgroundColor: ranks[card.rank].color }}>
                <div className="card-title">{card.title}</div>
                <div className="card-description">{card.description}</div>
                <div className='card-footer'>
                    <div className="card-id">{card.id}</div>
                    <div className="card-type">#{card.typetitle}</div>
                </div>
            </div>
        </div>
    );
};

export default Card;